import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {raise} from '@utilities/helpers.ts'
import {httpGetPatientLastInfo, HttpGetPatientLastInfoOptions} from './patients.http'
import {PatientLastInfo} from '@/features/patients/types'
import {AxiosError} from 'axios'

export const useGetPatientLastInfo = ({
    patientId,
    type,
    options
}: {
    patientId?: string
    type: HttpGetPatientLastInfoOptions['params']['type']
    options?: Omit<
        UseQueryOptions<PatientLastInfo, AxiosError<{message: string; code: string}>>,
        'queryKey' | 'queryFn'
    >
}) =>
    useQuery({
        queryKey: [QUERY_KEYS.PATIENTS, patientId, 'last-info', type],
        queryFn: () =>
            httpGetPatientLastInfo({
                urlParams: {patientId: patientId ?? raise('patientId is nullish')},
                params: {type}
            }),
        ...options
    })
